import { useRoutes } from '@/shared/routes';

export const lphRoutes = [
  {
    path: useRoutes.LPH_ITEM_PATH,
    name: useRoutes.LPH_ITEM_NAME,
    component: () => import('@/pages/LphItem'),
  },
  {
    path: useRoutes.LPH_LIST_PATH,
    name: useRoutes.LPH_LIST_NAME,
    component: () => import('@/pages/LphList'),
  },
];
